<div class="alert">
  <img [src]="srcPath"
    [width]="width"
    [height]="height" />
  <span>{{text}}</span>
</div>
<div class="edit_container">
  <span>{{rightText$ | async}}</span>
</div>
